import type { FinnovaCodeColumn } from '../../api/domain/finnova';
import type { IRootState } from '../root-reducer';

export const getSollProducts = (state: IRootState) => state.finnovaApi.sollProducts;
export const getKannProducts = (state: IRootState) => state.finnovaApi.kannProducts;
export const getIstProducts = (state: IRootState) => state.finnovaApi.istProducts;
export const getCardProducts = (state: IRootState) => state.finnovaApi.cardProducts;
export const getIstCards = (state: IRootState) => state.finnovaApi.istCards;
export const getPowerOfAttorneys = (state: IRootState) => state.finnovaApi.powerOfAttorneys;
export const getEBankingContracts = (state: IRootState) => state.finnovaApi.eBankingContracts;
export const getCommunicationEntries = (state: IRootState) => state.finnovaApi.communicationEntries;
export const getAddresses = (state: IRootState) => state.finnovaApi.addresses;
export const getFinnovaCodeTable = (state: IRootState) => state.finnovaApi.finnovaCodeTable;
export const getCodesByColumn = (columnName: FinnovaCodeColumn, state: IRootState) => getFinnovaCodeTable(state)[columnName];
